import {SearchModel} from "@fedelta-pos/data-client";
import {Injectable, Injector} from "@angular/core";
import {ScheduleData} from "../menu/menu-entity.model";

/**
 * Search model to retrieve the current active schedules
 */
@Injectable()
export class ActiveSchedulesSearchModel extends SearchModel<ScheduleData> {
    constructor(injector: Injector) {
        console.log("--- ActiveSchedulesSearchModel");
        super(injector, ScheduleData);
    }
}



// WEBPACK FOOTER //
// ./src/app/schedule/active-schedules-search.model.ts